export enum MsisdnStatus {
  UNSET_MSISDN_STATUS = 'UNSET_MSISDN_STATUS',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  LOCKED_PORT_IN = 'LOCKED_PORT_IN',
  PENDING_PORT_IN = 'PENDING_PORT_IN',
  PENDING_REVERSE_PORT_IN = 'PENDING_REVERSE_PORT_IN',
  PORTED_OUT = 'PORTED_OUT',
  PENDING_PORT_OUT = 'PENDING_PORT_OUT',
  PENDING_REVERSE_PORT_OUT = 'PENDING_REVERSE_PORT_OUT',
  SWAPPED = 'SWAPPED',
  RESERVED_TELECOM = 'RESERVED_TELECOM',
  DELETED = 'DELETED',
  RESERVED_SUPPORT = 'RESERVED_SUPPORT',
  LOCKED_RECYCLING = 'LOCKED_RECYCLING',
}
